module.exports = ".brand {\n  -ms-flex-line-pack: rigth;\n      align-content: rigth; }\n\n.align-buttons {\n  text-align: right; }\n\n.align-consecutive {\n  text-align: center; }\n\n.color-consecutive {\n  color: #f12121; }\n\n:host {\n  display: block;\n  width: 100%;\n  height: 100%; }\n\n:host .ngx-datatable {\n    height: 100vh; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-copy-estimate-customer/master-copy-estimate-customer.component.scss
// module id = ./src/app/master/master-copy-estimate-customer/master-copy-estimate-customer.component.scss
// module chunks = main